import { useAuth } from "@/context/AuthContext";
import { ShieldAlert } from "lucide-react";

export default function NotAuthorized() {
  const { user } = useAuth();
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="not-authorized">
      <div className="h-14 w-14 rounded-md bg-rose-500/10 border border-rose-500/30 flex items-center justify-center mb-4">
        <ShieldAlert className="h-7 w-7 text-rose-400" />
      </div>
      <div className="font-heading text-2xl font-bold uppercase tracking-wide text-slate-200">Access Restricted</div>
      <p className="text-sm text-slate-500 mt-2 max-w-md">
        Your role <span className="text-orange-400 font-mono">{user?.role}</span> does not have permission to view this section.
        Contact an administrator if you believe this is an error.
      </p>
    </div>
  );
}
